import store from '@/configuracoes/stores'

export default {

    resetarStore(modulo) {
        store.dispatch(modulo + '/resetar')
    },

    resetarTodasStores() {
        this.resetarStore('sessao')
        this.resetarStore('flash')
        this.resetarStore('geral')
        this.resetarStore('pendencias')
        this.resetarStore('lightbox')
    },

    stateParaFormData(data) {
        let formData = new FormData()
        this.objetoParaFormData(formData, data)
        return formData
    },

    objetoParaFormData(formData, data, parentKey) {
        if (data && (typeof data === 'object') && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                this.objetoParaFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
            })
        } else {
            const value = data == null ? '' : data
            formData.append(parentKey, value)
        }
    },

}
